module.exports = __webpack_public_path__ + "img/372.b236f141.jpg";